import { render, staticRenderFns } from "./SidebarModal.vue?vue&type=template&id=587168a6&"
import script from "./SidebarModal.vue?vue&type=script&lang=ts&"
export * from "./SidebarModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports